import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BringzzPageContainer, BringzzIcon, BringzzText, BringzzQrCode, BringzzButton } from "@bringzz/components";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const QRCodePage = () => {
    const query = useQuery();
    const employeeId = query.get('employeeId');
    const firstName = query.get('firstName');
    const lastName = query.get('lastName');
    const [copySuccess, setCopySuccess] = useState('');

    if (!employeeId) {
        return (
            <BringzzPageContainer
                header={{
                    left: <BringzzIcon
                        size="22"
                        icon="IconChevronLeft"
                        folder="LineIcons"
                        className="cursor-pointer"
                        onClick={() => window.history.back()}
                    />,
                    title: <BringzzText tag='h2'>Employee QR Code</BringzzText>,
                }}
            >
                <div className="flex flex-col items-center justify-center h-full p-4">
                    <BringzzText tag='h3' className="text-center text-gray-600">Employee ID is not available</BringzzText>
                </div>
            </BringzzPageContainer>
        );
    }

    const qrCodeValue = `${window.location.origin}/register/employee?employeeId=${employeeId}&firstName=${firstName}&lastName=${lastName}`;

    const handleShare = () => {
        navigator.clipboard.writeText(qrCodeValue)
            .then(() => {
                setCopySuccess('Link copied to clipboard!');
                setTimeout(() => setCopySuccess(''), 2000);
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
                setCopySuccess('Failed to copy the link.');
            });
    };

    return (
        <BringzzPageContainer
            header={{
                left: <BringzzIcon
                    size="22"
                    icon="IconChevronLeft"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={() => window.history.back()}
                />,
                title: <BringzzText tag='h2'>Employee QR Code</BringzzText>,
            }}
        >
            <div className="flex flex-col items-center justify-center min-h-[calc(100vh-64px)] p-6 space-y-6">
                <div className="flex flex-col items-center space-y-6">
                    <BringzzQrCode 
                        value={qrCodeValue} 
                        size={Math.min(270, window.innerWidth - 40)}
                        className="[&>h4]:hidden"
                    />
                    
                    <div className="text-center space-y-1">
                        <BringzzText tag="h3" className="text-xl font-medium">{firstName} {lastName}</BringzzText>
                        <BringzzText className="text-gray-500">ID: {employeeId}</BringzzText>
                    </div>

                    <BringzzButton 
                        onClick={handleShare}
                        className="px-8 py-3 rounded-lg bg-black hover:bg-gray-800 text-white transition-colors"
                    >
                        Copy Link
                    </BringzzButton>

                    {copySuccess && (
                        <BringzzText className={`text-sm ${copySuccess.includes('Failed') ? 'text-red-500' : 'text-green-500'}`}>
                            {copySuccess}
                        </BringzzText>
                    )}
                </div>
            </div>
        </BringzzPageContainer>
    );
};

export default QRCodePage;